import { IRestaurantCategory } from '@/shared/model/restaurant-category.model';
import { IRestaurantWorkingTimes } from '@/shared/model/restaurant-working-times.model';
import { IDeliverySpec } from '@/shared/model/delivery-spec.model';
import { IDiscount } from '@/shared/model/discount.model';
import { IRating } from '@/shared/model/rating.model';
import { IRestaurant, Restaurant } from '@/shared/model/restaurant.model';
import { IUser } from '@/shared/model/user.model';
import { ActionTree } from 'vuex';
import { RootState } from '../types';
import { IMenuCategory } from '@/shared/model/menu-category.model';
import { ICustomer } from '@/shared/model/customer.model';
import { IMarketer } from '@/shared/model/marketer.model';
import JhiDataUtils from '@/shared/data/data-utils.service';
import RestaurantService from '@/shared/services/restaurant.service';
import { IRestaurantMenuStore } from './types';
import RestaurantCategoryService from '@/shared/services/restaurant-category.service';
import RestaurantWorkingTimesService from '@/shared/services/restaurant-working-times.service';
import DeliverySpecService from '@/shared/services/delivery-spec.service';
import MenuCategoryService from '@/shared/services/menu-category.service';
import { IOrderDetail } from '@/shared/model/order/order-detail.model';
import { IOrderMenu, OrderMenu } from '@/shared/model/order/order-menu.model';
import { OrderAddon } from '@/shared/model/order/order-addon.model';

const jhiDataUtils = new JhiDataUtils();
const restaurantService = new RestaurantService();
const restaurantCategoryService = new RestaurantCategoryService();
const restaurantWorkingTimesService = new RestaurantWorkingTimesService();
const menuCategoryService = new MenuCategoryService();
const deliverySpecService = new DeliverySpecService();

export const actions: ActionTree<IRestaurantMenuStore, RootState> = {
  setRestaurant({ commit }, newRestaurant: IRestaurant) {
    commit('setRestaurant', newRestaurant);
  },
  setId({ commit }, newId: number): void {
    commit('setId', newId);
  },
  setName({ commit }, newName: string): void {
    commit('setName', newName);
  },
  setLogoContentType({ commit }, newLogoContentType: string): void {
    commit('setLogoContentType', newLogoContentType);
  },
  setLogo({ commit }, newLogo: string): void {
    commit('setLogo', newLogo);
  },
  setImageContentType({ commit }, newImageContentType: string): void {
    commit('setImageContentType', newImageContentType);
  },
  setImage({ commit }, newImage: string): void {
    commit('setImage', newImage);
  },
  setFile({ commit }, { entity, file }: { entity: string; file: File }): void {
    const convert: IRestaurant = jhiDataUtils.setFileData(file, new Restaurant(), entity);
    setTimeout(() => {
      commit(`set${entity.charAt(0).toUpperCase() + entity.slice(1)}`, convert[`${entity}`]);
      commit(`set${entity.charAt(0).toUpperCase() + entity.slice(1)}ContentType`, convert[`${entity}ContentType`]);
    }, 100);
  },
  setZipcode({ commit }, newZipcode: string): void {
    commit('setZipcode', newZipcode);
  },
  setStreet({ commit }, newStreet: string): void {
    commit('setStreet', newStreet);
  },
  setAddressAddition({ commit }, newAddressAddition: string): void {
    commit('setAddressAddition', newAddressAddition);
  },
  setNumber({ commit }, newNumber: string): void {
    commit('setNumber', newNumber);
  },
  setCity({ commit }, newCity: string): void {
    commit('setCity', newCity);
  },
  setPhone({ commit }, newPhone: string): void {
    commit('setPhone', newPhone);
  },
  setRegisterNumber({ commit }, newRegisterNumber: string): void {
    commit('setRegisterNumber', newRegisterNumber);
  },
  setTaxIdentificationNumber({ commit }, newTaxIdentificationNumber: string): void {
    commit('setTaxIdentificationNumber', newTaxIdentificationNumber);
  },
  setDeliver({ commit }, newDeliver: boolean): void {
    commit('setDeliver', newDeliver);
  },
  setPickup({ commit }, newPickup: boolean): void {
    commit('setPickup', newPickup);
  },
  setBankAccountName({ commit }, newBankAccountName: string): void {
    commit('setBankAccountName', newBankAccountName);
  },
  setIbanNumber({ commit }, newIbanNumber: string): void {
    commit('setIbanNumber', newIbanNumber);
  },
  setPep({ commit }, newPep: boolean): void {
    commit('setPep', newPep);
  },
  setEnabled({ commit }, newEnabled: boolean): void {
    commit('setEnabled', newEnabled);
  },
  setStartingDate({ commit }, newStartingDate: Date): void {
    commit('setStartingDate', newStartingDate);
  },
  setStartingDateString({ commit }, newStartingDateString: string): void {
    commit('setStartingDateString', newStartingDateString);
  },
  setDomain({ commit }, newDomain: boolean): void {
    commit('setDomain', newDomain);
  },
  setMenuCard({ commit }, newMenuCard: string): void {
    commit('setMenuCard', newMenuCard);
  },
  setMenuCardContentType({ commit }, newMenuCardContentType: string): void {
    commit('setMenuCardContentType', newMenuCardContentType);
  },
  setMenuCardPath({ commit }, newMenuCardPath: string): void {
    commit('setMenuCardPath', newMenuCardPath);
  },
  setIdCard({ commit }, newIdCard: string): void {
    commit('setIdCard', newIdCard);
  },
  setIdCardContentType({ commit }, newIdCardContentType: string): void {
    commit('setIdCardContentType', newIdCardContentType);
  },
  setIdCardPath({ commit }, newIdCardPath: string): void {
    commit('setIdCardPath', newIdCardPath);
  },
  setCocRegistration({ commit }, newCocRegistration: string): void {
    commit('setCocRegistration', newCocRegistration);
  },
  setCocRegistrationContentType({ commit }, newCocRegistrationContentType: string): void {
    commit('setCocRegistrationContentType', newCocRegistrationContentType);
  },
  setCocRegistrationPath({ commit }, newCocRegistrationPath: string): void {
    commit('setCocRegistrationPath', newCocRegistrationPath);
  },
  setbankCard({ commit }, newbankCard: string): void {
    commit('setbankCard', newbankCard);
  },
  setbankCardContentType({ commit }, newbankCardContentType: string): void {
    commit('setbankCardContentType', newbankCardContentType);
  },
  setbankCardPath({ commit }, newbankCardPath: string): void {
    commit('setbankCardPath', newbankCardPath);
  },
  setUser({ commit }, newUser: IUser): void {
    commit('setUser', newUser);
  },
  setFoodDiscount({ commit }, newFoodDiscount: IDiscount): void {
    commit('setFoodDiscount', newFoodDiscount);
  },
  setNonfoodDiscount({ commit }, newNonfoodDiscount: IDiscount): void {
    commit('setNonfoodDiscount', newNonfoodDiscount);
  },
  setRatings({ commit }, newRatings: IRating[]): void {
    commit('setRatings', newRatings);
  },
  setDeliverySpecs({ commit }, newDeliverySpecs: IDeliverySpec[]): void {
    commit('setDeliverySpecs', newDeliverySpecs);
  },
  setRestaurantWorkingTimes({ commit }, newRestaurantWorkingTimes: IRestaurantWorkingTimes[]): void {
    commit('setRestaurantWorkingTimes', newRestaurantWorkingTimes);
  },
  setMenuCategories({ commit }, newMenuCategories: IMenuCategory[]): void {
    commit('setMenuCategories', newMenuCategories);
  },
  setRestaurantCategories({ commit }, newRestaurantCategories: IRestaurantCategory[]): void {
    commit('setRestaurantCategories', newRestaurantCategories);
  },
  setCustomer({ commit }, newCustomer: ICustomer): void {
    commit('setCustomer', newCustomer);
  },
  setMarketer({ commit }, newMarketer: IMarketer): void {
    commit('setMarketer', newMarketer);
  },
  setIsDeliver({ commit }, newIsDeliver: boolean): void {
    commit('setIsDeliver', newIsDeliver);
  },
  updateRestaurantStateMember({ commit }, payload): void {
    commit('updateRestaurantStateMember', payload);
  },
  async retrieveRestaurant({ commit }, { id, zipcode }): Promise<boolean> {
    if (zipcode) {
      try {
        const restaurant = await restaurantService.getRestaurant(id, zipcode);
        localStorage.setItem('ll-restaurant', JSON.stringify(restaurant));
        commit('setRestaurant', restaurant);
        return true;
      } catch (error) {
        if (error.response?.status === 404) {
          return false;
        } else {
          throw error;
        }
      }
    }
  },
  addToBasket({ commit }, orderMenu: IOrderMenu): void {
    const orderMenuClone = new OrderMenu();
    orderMenuClone.menuId = orderMenu.menuId;
    orderMenuClone.variantId = orderMenu.variantId;
    orderMenuClone.menuTitle = orderMenu.menuTitle;
    orderMenuClone.menuVariantTitle = orderMenu.menuVariantTitle;
    orderMenuClone.price = orderMenu.price;
    orderMenuClone.hash = orderMenu.hash;
    orderMenuClone.menuCosts = orderMenu.menuCosts;
    orderMenuClone.quantity = orderMenu.quantity;
    orderMenuClone.remark = orderMenu.remark;
    orderMenuClone.nonfood = orderMenu.nonfood;
    orderMenuClone.imagePath = orderMenu.imagePath;
    orderMenuClone.addons = orderMenu.addons.map(orderAddon => {
      return new OrderAddon(
        orderAddon.addonId,
        orderAddon.title,
        orderAddon.price,
        orderAddon.quantity,
        orderAddon.costs,
        orderAddon.single
      );
    });
    commit('addToBasket', orderMenuClone);
  },
  deleteOrderMenu({ commit }, i: number) {
    commit('deleteOrderMenu', i);
  },
  setAddressForDelivery({ commit }, address) {
    commit('setAddressForDelivery', address);
  },
  setOrderDetail({ commit }, newOrderDetail: IOrderDetail) {
    commit('setOrderDetail', newOrderDetail);
  },
  resetBasket({ commit }) {
    commit('resetBasket');
  },
};
